import { Granulometry } from '../../domain/granulometry/Granulometry';

export const GRANULOMETRY_UPDATED = 'granulometry/updated';

export const granulometryUpdated = (granulometry?: Granulometry) => {
  return <const>{ type: GRANULOMETRY_UPDATED, payload: { granulometry } };
};

export type GranulometryUpdatedAction = ReturnType<typeof granulometryUpdated>;
